const TYPE = 'SAVE_DEVICE';

const action = (data) => (dispatch) => dispatch({ type: TYPE, payload: data });

export { action, TYPE };
